import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import OldProgressTracker from './progress-tracker';
import NewProgressTracker from './progress-tracker-new';
/**
 * `ProgressTrackerFacade` is a component that conditionally renders either a new functional ProgressTracker component or
 *  class based ProgressTracker component based on a feature flag.
 *
 */
export var ProgressTrackerFacade = function ProgressTrackerFacade(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var useNewProgressTracker = fg('platform-progress-tracker-functional-facade');
  return useNewProgressTracker ? jsx(NewProgressTracker, props) : jsx(OldProgressTracker, props);
};
export default ProgressTrackerFacade;